import React from 'react';
import { TitleWrapper } from './TitleStyles';

const TitleSection = ({ children, textColor }) => {
    return ( 
        <TitleWrapper textColor={textColor}>
            <h1>{children}</h1>
        </TitleWrapper>
    )
}

export default TitleSection;